import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import { useAuthStore } from '@/stores/auth'

// Element Plus 样式
import 'element-plus/dist/index.css'

// 全局样式
import './styles/index.scss'

// NProgress 样式
import 'nprogress/nprogress.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// 暴露应用实例给API拦截器使用
window.__app__ = app

// 监听认证过期事件
window.addEventListener('auth-expired', () => {
  const authStore = useAuthStore()
  authStore.logout()
  if (router.currentRoute.value.path !== '/login') {
    router.push('/login')
  }
})

// 🔧 初始化认证状态 - 确保页面刷新后保持登录状态
const initApp = async () => {
  const authStore = useAuthStore()
  
  // 先挂载应用（避免阻塞）
  app.mount('#app')
  
  // 然后异步恢复认证状态
  try {
    await authStore.initAuth()
    console.log('✅ 认证状态初始化完成')
  } catch (error) {
    console.warn('⚠️ 认证状态初始化失败:', error)
  }
}

// 直接初始化应用
initApp() 